export default "__VITE_ASSET__WrsRj6RA__"